import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { FootnotesPipe } from '@hyundai/ng-common-lib';

@Component({
    standalone: true,
    imports: [FootnotesPipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'lib-key-value',
    template: `
        <div class="leading-21 flex justify-between gap-4 text-14">
            @let label = key() | footnotes;
            <span class="text-grey-400" [innerHTML]="label()"></span>
            @if (value(); as val) {
                <span class="text-right font-medium text-black">{{ val }}</span>
            }
        </div>
    `,
})
export class KeyValueComponent {
    key = input.required<string>();
    value = input<string | null | boolean>();
}
